import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import Destination from '@web-ui-kit/destination'
import * as Sc from './ProfileMenu.style'
import { ROUTES } from 'routes/paths'
import { logout } from 'store/actions/user.actions'

const ProfileMenu = () => {
  const { t } = useTranslation()
  const { push } = useHistory()
  const dispatch = useDispatch()

  return (
    <Sc.Container>
      <Destination
        dataTestId='button-profile'
        fullWidth
        icon={{ height: 24, name: 'user', width: 24 }}
        onClick={() => push(ROUTES.ACCOUNT)}
        text={t('common.navigation.user_menu.profile', { keySeparator: '.' })}
      />
      <Sc.Divider />
      <Destination
        dataTestId='button-logout'
        icon={{ height: 24, name: 'logOut', width: 24 }}
        onClick={() => dispatch(logout())}
        text={t('common.navigation.user_menu.logout', { keySeparator: '.' })}
      />
    </Sc.Container>
  )
}

export default ProfileMenu
